import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTabsStore } from "@/contexts/tabs-context";
import type { TabSearchParams } from "@/routing/core/locations";

/**
 * The only coupling between TanStack Router location changes and TabsStore.
 * Browser-initiated URL changes win; navigation guards apply to store actions.
 */
export function RouterBridge() {
  const store = useTabsStore();
  const location = useLocation();

  useEffect(() => {
    store.handleUrlChange(location.pathname, location.search as TabSearchParams);
  }, [store, location.pathname, location.search]);

  return null;
}
